import { projectsSlice } from "./reducer";

export const {
  projectsFetchLoadingStart,
  projectsFetchLoadingSuccess,
  projectsFetchLoadingFail,
  projectsReset,
} = projectsSlice.actions;
